import Route from 'cio/routes/base';

export default class ErrorsRoute extends Route {
  model(params: { error_id: string }) {
    return params.error_id;
  }
}
